import React from 'react'
import BootInfoContent from '../../Component/BootInfo/BootInfoContent'

function BootInfo() {
  return (
    <div>  
      <BootInfoContent />
      
    </div>
  )
}

export default BootInfo
